export default __webpack_public_path__ + "static/media/IMAGE_6.0e02632d.png";